var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown-item',_vm._g(_vm._b({staticClass:"action-dropdown-item"},'b-dropdown-item',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('icon',{staticClass:"dropdown-item-icon",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }